import { Injectable } from '@angular/core';

import { GoodsReceivedNoteEdit, GoodsReceivedNoteSearch } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class GoodsReceivedNoteService extends TmsWebBaseEditService<GoodsReceivedNoteSearch, GoodsReceivedNoteEdit> {
  constructor() {
    super('GoodsReceivedNote', $localize`Goods Received Note`);
  }
}
